import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";
import { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "components/Headers/Header";
import Cookies from "universal-cookie";

const CreaPropietario = () => {
  const cookie = new Cookies();
  const [formData, setFormData] = useState({
    nombre: "",
    documento: "",
    telefono: "",
    correo: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const postData = (e) => {
    e.preventDefault();

    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://inspecciongnvback-dev.azurewebsites.net/api/v1/CreaPropietario",
      data: formData,
    })
      .then((response) => {
        // Validar si la respuesta es 0
        if (response.data === 0) {
          Swal.fire({
            icon: "warning",
            title: "Taller inactivo",
            text: "El taller está inactivo. Debe actualizar su información o comunicarse con el administrador del sistema.",
            confirmButtonColor: "#f0ad4e",
            confirmButtonText: "Entendido",
          });
          return; // No continuar con la navegación
        }

        // Si todo está correcto, continuar con el flujo normal
        Swal.fire({
          icon: "success",
          title: "¡Propietario creado!",
          text: "El propietario ha sido registrado exitosamente.",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Continuar",
        }).then(() => {
          window.location.href = "/admin/CreaVehiculo/" + response.data;
        });
      })
      .catch((error) => {
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Ocurrió un problema al crear el propietario: " + error.message,
          confirmButtonColor: "#d33",
          confirmButtonText: "Cerrar",
        });
      });
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <Col className="order-xl-1" xl="12">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0"> Información del propietario</h3>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Form onSubmit={postData}>
                  <div className="pl-lg-4">
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label htmlFor="nombre">Nombre</label>
                          <Input
                            className="form-control-alternative"
                            id="nombre"
                            name="nombre"
                            type="text"
                            onChange={handleChange}
                            required
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label htmlFor="documento">Documento</label>
                          <Input
                            className="form-control-alternative"
                            id="documento"
                            name="documento"
                            type="text"
                            onChange={handleChange}
                            required
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label htmlFor="telefono">Teléfono</label>
                          <Input
                            className="form-control-alternative"
                            id="telefono"
                            name="telefono"
                            type="text"
                            onChange={handleChange}
                            required
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label htmlFor="correo">Correo</label>
                          <Input
                            className="form-control-alternative"
                            id="correo"
                            name="correo"
                            type="email"
                            onChange={handleChange}
                            required
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                  <hr className="my-4" />
                  <Button color="primary" size="lg" type="submit">
                    SIGUIENTE
                  </Button>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CreaPropietario;
